// @flow

import _ from "lodash";
import humanizeDuration from "humanize-duration";
import * as React from "react";
import { ProgressBar } from "react-bootstrap";

import "./TimeProgressBar.css";

type Props = {
  now: number,
  max: number
};

function bsStyleFromSecs(secsRemaining: number): string | null {
  if (secsRemaining > 10) {
    return null;
  } else if (secsRemaining > 3) {
    return "warning";
  } else {
    return "danger";
  }
}

const TimeProgressBar = (props: Props) => {
  const secsRemaining = _.max([0, _.round(props.max - props.now)]);

  const bsStyle = bsStyleFromSecs(secsRemaining);
  return (
    <div className="TimeProgressBar">
      {" "}
      <ProgressBar
        min={0}
        max={props.max}
        now={props.now}
        active={false}
        striped={false}
        bsStyle={bsStyle}
      />
      <div className="TimeProgressBar-Label">
        {humanizeDuration(secsRemaining * 1000)} remaining
      </div>
    </div>
  );
};

export default TimeProgressBar;



// WEBPACK FOOTER //
// ./src/components/TimeProgressBar/TimeProgressBar.js